import React from "react";
import {
    AlertDialog,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogFooter,
    AlertDialogAction,
} from "../ui/alert-dialog";

function HowToPlayPopup({ open, onClose }) {
    return (
        <AlertDialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
            <AlertDialogContent
                handleMouseDownOnOverlay={onClose}
                onEscapeKeyDown={onClose}
                className="max-w-md"
            >
                <AlertDialogHeader>
                    <AlertDialogTitle className="text-xl sm:text-2xl font-bold text-white">How Sports Connections works</AlertDialogTitle>
                </AlertDialogHeader>
                <div className="space-y-4 py-2 text-slate-200">
                    <p className="text-base">
                        Pick a sport and find four groups of two to four items that share a connection.
                    </p>
                    <p className="text-base">
                        Tap tiles to select them, hit Submit, and solve the grid before you use all four mistakes.
                    </p>

                    <div className="space-y-4 pt-2">
                        <div>
                            <h4 className="text-sm font-bold uppercase tracking-wide text-slate-400 mb-2">
                                Quick examples
                            </h4>
                            <ul className="space-y-1 text-sm text-slate-300">
                                <li><span className="font-semibold text-white">NFL QUARTERBACKS:</span> Tom Brady, Peyton Manning, Joe Montana, Brett Favre</li>
                                <li><span className="font-semibold text-white">NBA PLAYMAKERS:</span> Chris Paul, Steve Nash, John Stockton, Jason Kidd</li>
                                <li><span className="font-semibold text-white">MLB BALLPARKS:</span> Fenway Park, Wrigley Field, Yankee Stadium, Dodger Stadium</li>
                            </ul>
                        </div>
                        <div>
                            <h4 className="text-sm font-bold uppercase tracking-wide text-slate-400 mb-2">
                                Difficulty colors
                            </h4>
                            <ul className="space-y-2 text-sm text-slate-300">
                                <li className="flex items-center gap-2">
                                    <span className="h-4 w-4 rounded-full border border-white/10" style={{ backgroundColor: "#f9dc5c" }} />
                                    Yellow = easiest
                                </li>
                                <li className="flex items-center gap-2">
                                    <span className="h-4 w-4 rounded-full border border-white/10" style={{ backgroundColor: "#78c788" }} />
                                    Green = medium
                                </li>
                                <li className="flex items-center gap-2">
                                    <span className="h-4 w-4 rounded-full border border-white/10" style={{ backgroundColor: "#6cb4ee" }} />
                                    Blue = hard
                                </li>
                                <li className="flex items-center gap-2">
                                    <span className="h-4 w-4 rounded-full border border-white/10" style={{ backgroundColor: "#ba9bc8" }} />
                                    Purple = trickiest
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <AlertDialogFooter>
                    <AlertDialogAction onClick={onClose} className="w-full sm:w-auto">
                        Close
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}

export default HowToPlayPopup;
